<template>
  <t-modal
    :visible="visible"
    no-close-on-backdrop
    @update:visible="$emit('update:visible', $event)"
    @close="$emit('close')"
  >
    <div class="p-4">
      <h3 class="mb-2">{{ $t('chat_evaluation.title') }}</h3>
      <p>{{ $t('chat_evaluation.msg') }}</p>
      <div class="flex items-center text-center mt-4">
        <t-button class="w-1/2" outline @click="$emit('dislike')">{{
          $t('chat_evaluation.not_satisfied')
        }}</t-button>
        <t-button class="w-1/2 ml-2" @click="$emit('like')">{{
          $t('chat_evaluation.satisfied')
        }}</t-button>
      </div>
    </div>
  </t-modal>
</template>

<script>
export default {
  name: 'ChatEvaluationModal',

  props: {
    visible: Boolean
  }
}
</script>
